import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { NavigationService } from '../navigation.service';

@Injectable({
    providedIn: 'root',
})
export class NavigationGuard implements CanActivate {
    constructor(private navigationService: NavigationService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (this.navigationService.isAccessAllowed(state.url.split('?')[0])) {
            return true;
        }

        this.navigationService.navigateToDashboard();
        return false;
    }
}
